import { render, staticRenderFns } from "./BusinessReview.vue?vue&type=template&id=0408b762"
import script from "./BusinessReview.vue?vue&type=script&lang=js"
export * from "./BusinessReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteRating: require('/opt/atlassian/pipelines/agent/build/components/SiteRating.vue').default,UserItem: require('/opt/atlassian/pipelines/agent/build/components/user/UserItem.vue').default,FormSiteInput: require('/opt/atlassian/pipelines/agent/build/components/form/SiteInput.vue').default,FormSiteButton: require('/opt/atlassian/pipelines/agent/build/components/form/SiteButton.vue').default,SiteModal: require('/opt/atlassian/pipelines/agent/build/components/SiteModal.vue').default})
